import { i18n } from '@/locales';

const t = function (key) {
  return i18n.t(key);
};

export const TaskStatusOptions = [
  { label: t('enum.taskStatus.created'), value: 'CREATED' },
  { label: t('enum.taskStatus.scanning'), value: 'RUNNING' },
  { label: t('enum.taskStatus.success'), value: 'SUCCESS' },
  { label: t('enum.taskStatus.failed'), value: 'FAILED' },
];

export const SeverityOptions = [
  { label: t('enum.severity.critical'), value: 'Critical' },
  { label: t('enum.severity.high'), value: 'High' },
  { label: t('enum.severity.medium'), value: 'Medium' },
  { label: t('enum.severity.low'), value: 'Low' },
];

export const PurchaseStatusOptions = [
  { label: t('enum.purchaseStatus.notPurchased'), value: 'NOT_PURCHASED' },
  { label: t('enum.purchaseStatus.purchased'), value: 'PURCHASED' },
  { label: t('enum.purchaseStatus.pending'), value: 'PENDING' },
];

export const ScanDataKey = 'ScanData';
export const consentCookieKey = 'cc_cookie';
export const LocaleKey = 'Locale';
export const RemoteBrowserUrlKey = 'remoteBrowserUrl';

export const RoleOptions = [
  {
    value: 'admin',
    label: t('enum.role.admin'),
  },
  {
    value: 'normal',
    label: t('enum.role.normal'),
  },
];

export const LANGUAGE_TYPES = {
  JAVA: 'JAVA',
  JAVASCRIPT: 'JAVASCRIPT',
  PYTHON: 'PYTHON',
};

// Usage example in a Vue component:
// import { TaskStatusOptions } from '@/enum';
//
// export default {
//   data() {
//     return {
//       taskStatusOptions: TaskStatusOptions
//     };
//   }
// };

export const AccessTokenKey = 'assess_token';
export const RefreshTokenKey = 'refresh_token';
